import type { Paginated } from '@partou/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AppContextService, DEFAULT_LIMIT } from '@partou/core';
import { map, type Observable } from 'rxjs';
import type { ApiGroupsResponse, Group, GroupsQuery } from '../types';
import { toGroup } from '../mappers/groups.api';

const GROUPS_ENDPOINT: Readonly<string> = '/groups';
const SORT_FIELD: Readonly<string> = 'name';
const SORT_DIRECTION: Readonly<string> = 'ASC';

@Injectable()
export class GroupsApiService {
  private readonly http: HttpClient = inject(HttpClient);
  private readonly context: AppContextService = inject(AppContextService);

  getGroups(query: GroupsQuery = {}): Observable<Paginated<Group>> {
    let params: HttpParams = new HttpParams()
      .set('limit', query.limit ?? DEFAULT_LIMIT)
      .set('offset', query.offset ?? 0)
      .set('sortField', SORT_FIELD)
      .set('sortDirection', SORT_DIRECTION);
    if (query.locationId !== undefined && query.locationId !== '') {
      params = params.set('locationId', query.locationId);
    }
    if (query.nameSearch !== undefined && query.nameSearch !== '') {
      params = params.set('nameSearch', query.nameSearch);
    }
    return this.http.get<ApiGroupsResponse>(this.context.buildEndpoint(GROUPS_ENDPOINT), { params }).pipe(
      map(
        (response: ApiGroupsResponse): Paginated<Group> => ({
          items: response.items.map(toGroup),
          total: response.pagination?.total,
        }),
      ),
    );
  }
}
